<template>
    <div class="get-today">
        <slot name="link"/>
        <DefLink
            class="get-today__link"
            @click="isOpen = true"
        >
            <span>
                {{ messages.getToday }}
            </span>
        </DefLink>
        <DefSlideModal
            :active="isOpen"
            @close="handlerClose"
        >

            <template #title>
                {{ messages.getToday }}
            </template>

<!--            <ProductModal-->
<!--                :result="result"-->
<!--                :messages="messages"-->
<!--            />-->


            <GetTodayList
                v-if="!currentReserveShop"
                :result="result"
                :messages="messages"
                @reserve="handlerReserve"
            />
            <GetTodayDetail
                v-else
                :result="result"
                :reserveShop="currentReserveShop"
                :messages="messages"
                @close="handlerClose"
            />

        </DefSlideModal>
    </div>
</template>

<script>
import DefLink from "../../def/DefLink/DefLink";
import DefSlideModal from "../../def/DefSlideModal/DefSlideModal";

export default {
    name: 'GetToday',
    components: {
        DefLink,
        DefSlideModal
    },
    props: ['result', 'messages'],
    data() {
        return {
            isOpen: false,
            currentReserveShop: null,
        }
    },
    methods: {
        doOpen() {
            this.isOpen = true;
        },
        handlerReserve(item) {
            this.currentReserveShop = item;
        },
        handlerClose() {
            this.isOpen = false;
            this.currentReserveShop = null;
        }
    }
}
</script>

<style lang="scss" scoped>
.get-today {
    :deep(.def-slide-modal__block) {
        padding: 40px 6px 24px 16px;
        @include point-md {
            padding: 36px 14px 32px 24px;
        }
        @include point-lg {
            //width: 1340px;
            padding: 68px 40px 60px 60px;
        }
    }

    //:deep(.product-modal) {
    //    max-width: 320px;
    //}
}
</style>